// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__25ANi","info":"Note_info__18e_P","note":"Note_note__3PVYD","actions":"Note_actions__20AxJ"};